import axios from 'axios'

export const axiosProgressUploading = (url, data, setPercentsCompletition) =>
  axios.put(url, data, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    onUploadProgress: (progress) => {
      setPercentsCompletition(
        Math.round((progress.loaded * 100) / progress.total)
      )
    },
  })
